import { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faBook,
    faCloud,
    faDesktop, faDollarSign,
    faEthernet,
    faHandshake,
    faKey,
    faMobileAlt, faPhone, faShieldVirus, faSms, faSoap,
    faVirus
} from '@fortawesome/free-solid-svg-icons';

import IMask from 'imask';
import { Link } from 'react-router-dom';
import {faMicrosoft} from "@fortawesome/free-brands-svg-icons";
import {Helmet} from "react-helmet";

const BlogsComponent = () => {
    useEffect(() => {
        document.title = "Blog | Riverland Technology Services"
    }, []);

    
    return (
       <>
           <Helmet>
               <meta
                   name="description"
                   content="Check out our latest blog posts!"
               />
           </Helmet>
           <section className="section ProductHeroSection WebDevProductHeroSection HeroSection Section--hasGuides theme--light accent--Blue">
                <div className="section_masked">
                    <div className="section_backgroundMask">
                        <div className="section_background">
                            <div className="guides hero-guides">
                                <div className="guidesContainer">
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sectionContainer">
                        <div className="sectionLayoutContainer">
                            <div className="sectionLayout">
                                <div className="RowLayout ProductHeroSection_layout">
                                    <nav className="ProductNav">
                                        <header className="ProductNav_header">
                                            <h1 className="ProductNav_title">Riverland Technology Services</h1>
                                        </header>
                                        <div className="HorizontalOverflowContainer">
                                            <div className="HorizontalOverflowContainer_track">
                                                <div className="HorizontalOverflowContainer_items">
                                                    <ul className="ProductNav_linkList">
                                                        <li className="ProductNavItem ProductNavItem--isActive">
                                                            <Link to="/blog" className="link">Blog</Link>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </nav>
                                    <div className="ProductHeroSection_content">
                                        <div className="RowLayout">
                                            <section className="Copy variant--Hero">
                                                <header className="Copy_header">
                                                    <h1 className="CopyTitle">
                                                        Riverland Technology Services' Blog
                                                    </h1>
                                                </header>
                                            </section>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section theme--dark accent--Blue">
            <div className="section_masked">
                    <div className="section_backgroundMask">
                        <div className="section_background">
                            <div className="guides hero-guides">
                                <div className="guidesContainer">
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                    <div className="guides-guide"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sectionContainer">
                        <div className="sectionLayoutContainer">
                            <div className="sectionLayout">
                                <div className="RowLayout">
                                    <div>
                                        <div className="ColumnLayout" data-columns="1,1,1,1">
                                            <Link to="/blog/the-importance-of-blogging">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faBook} /></div>
                                                        <h1 className="CopyTitle">The Importance of a Blog</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        A blog is a crucial part of a website, especially for a small-to-medium business. Why is that though?
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/sms-mfa">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faSms} /></div>
                                                        <h1 className="CopyTitle">Why you should <i>NEVER</i> use SMS 2FA</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        2FA is a must for keeping your accounts safe. It protects you from password leaks, brute forcing, and more, but which type should you use?
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/3cx-breach">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faPhone} /></div>
                                                        <h1 className="CopyTitle">The recent 3CX Security Breach</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        3CX, the Phone System we use and resell, recently had a security breach. In what's known as a Supply Chain attack, 3CX unknowingly distributed malware to anyone using the 3CX Desktop App on Windows and...
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/how-to-keep-your-computer-clean">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faSoap} /></div>
                                                        <h1 className="CopyTitle">How to keep your computer clean!</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        When your computer is full of unused software and files, your computer can feel a bit more slow, or sluggish. Computers have to be maintained, like a car, you need to occasionally go through and remove any unnecessary bloat.
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/the-msp-buyers-guide">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faDollarSign} /></div>
                                                        <h1 className="CopyTitle">The MSP Buyer's Guide!</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        Looking for an MSP, or knowing what to purchase from an MSP can be difficult, but we're here to help! In this blog post, we'll walk through what to look for, how much to spend, and what services you need from an MSP!
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/how-to-keep-yourself-cybersecure">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faShieldVirus} /></div>
                                                        <h1 className="CopyTitle">How to keep yourself cybersecure!</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        Cybersecurity is a complicated topic, however, in this blog post, I'll talk about some of the ways you can keep yourself safe from cyberattacks!
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/the-power-of-microsoft-365">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faMicrosoft} /></div>
                                                        <h1 className="CopyTitle">The Power of Microsoft 365</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        Microsoft 365 has many hidden talents, especially in their Business Premium plan. So how can you use Microsoft 365 to its fullest extent?
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/what-is-the-cloud-really">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faCloud} /></div>
                                                        <h1 className="CopyTitle">What is the Cloud really?</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        In short, the Cloud is just someone else's computer. Its that simple. The Cloud is posed by a lot of people as this revolutionary and amazing way to do computing and technology, but its not as revolutionary and amazing as others would like you to believe...
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/vpns-what-are-they-do-i-need-one">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faEthernet} /></div>
                                                        <h1 className="CopyTitle">VPNs: What are they? Do I need one?</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        A VPN is a tunnel, typically through the internet, that connects two seperated networks together. For example, if you have two business locations, or you have an employee working from home, you can use a VPN to access...
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/what-is-an-msp">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faDesktop} /></div>
                                                        <h1 className="CopyTitle">What is an MSP?</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        As part of my SACE Stage 2 Research Project, I had to answer this question. It's a pretty simple question, with a simple answer, an MSP is a business that offers outsource IT management to a business. But an MSP does a lot more...
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/what-antivirus-should-i-get">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faVirus} /></div>
                                                        <h1 className="CopyTitle">What Antivirus should I get?</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        Antiviruses are an important tool for keeping your computer safe, but how do I know which one is right for me? In this post we'll talk about some of the major Antivirus software, and see which one is right for you.
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/why-you-need-a-password-manager">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faKey} /></div>
                                                        <h1 className="CopyTitle">Why you need a Password Manager</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        A Password Manager is a tool that stores and generates passwords for you. It can do a lot more than that though, such as automatically fill in passwords for you, share passwords between devices and more!
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/why-ransomware-is-a-threat">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faVirus} /></div>
                                                        <h1 className="CopyTitle">Why Ransomware is a Threat</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        Ransomware is one of the most common types of cyber attacks, and the ACSC (Australian Cyber Security Centre) received reports of over 440 ransomware attacks in Australia from 2021-2022. It's where a bad actor will gain access to your systems, and most likely, encrypt all or most of your files...
                                                    </div>
                                                </div>
                                            </Link>
                                            <Link to="/blog/why-you-should-choose-local">
                                                <div className="Copy variant--Detail">
                                                    <header className="Copy_header link">
                                                        <div className="CopyIcon"><FontAwesomeIcon className="CopyIcon-icon" icon={faHandshake} /></div>
                                                        <h1 className="CopyTitle">Why You Should Choose Local</h1>
                                                        <h5>By Shaun Fulham</h5>
                                                    </header>
                                                    <div className="Copy_body">
                                                        No matter what services you are looking to outsource for your business, whether that be photography, IT, accounting, or otherwise, there are always advantages to going local.
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

       </>
    );
}

export default BlogsComponent